import React from 'react';

import { Menu, Typography, Dropdown } from 'antd';
import PropTypes from 'prop-types';

import {
  SafetyCertificateOutlined,
  SafetyCertificateFilled,
} from '@ant-design/icons';

import './ProductSubscription.less';

const { Text } = Typography;

const COLOR_MAP = {
  yellow: { tooltip: 'Received from GDSN, and modified' },
  blue: { tooltip: 'Subscribed Member' },
  red: { tooltip: 'Subscribed Member' },
};

const MemberSubscription = ({ color, isFill }) => {
  const colorClass = color?.toLowerCase();
  const { tooltip = '' } = COLOR_MAP[colorClass] || {};

  const overLay = (
    <Menu style={{ padding: 4, fontWeight: 900 }}>
      <Menu.Item>
        <Text strong>{tooltip}</Text>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className='pd-subscribe'>
      <Dropdown overlay={overLay} placement='bottomRight'>
        {isFill ? (
          <SafetyCertificateFilled
            className={`pd-subscribe__icon pd-subscribe__icon--` + colorClass}
          />
        ) : (
          <SafetyCertificateOutlined
            className={`pd-subscribe__icon pd-subscribe__icon--` + colorClass}
          />
        )}
      </Dropdown>
    </div>
  );
};

MemberSubscription.propTypes = {
  color: PropTypes.string,
  isFill: PropTypes.bool,
};

export default MemberSubscription;
